<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Dialbot" class="d-icon d-icon--dialbot" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="3.5" :fill="`url(#${uniqueID}a)`"/><path d="M17.8 18v.8h1.295l-.58-1.158L17.8 18Zm-1.121-2.243-.624-.501-.321.4.23.459.715-.358ZM12 6.8a5.2 5.2 0 0 1 5.2 5.2h1.6A6.8 6.8 0 0 0 12 5.2v1.6ZM6.8 12A5.2 5.2 0 0 1 12 6.8V5.2A6.8 6.8 0 0 0 5.2 12h1.6Zm5.2 5.2A5.2 5.2 0 0 1 6.8 12H5.2a6.8 6.8 0 0 0 6.8 6.8v-1.6Zm5.8 0H12v1.6h5.8v-1.6Zm-1.837-1.085 1.122 2.243 1.43-.716-1.12-2.243-1.432.716ZM17.2 12a5.175 5.175 0 0 1-1.145 3.256l1.247 1.002A6.775 6.775 0 0 0 18.8 12h-1.6Zm-2 1.6a4.823 4.823 0 0 1-1.491.886 4.816 4.816 0 0 1-3.418 0A4.822 4.822 0 0 1 8.8 13.6v-.8c.295.178.628.33.999.46a7.59 7.59 0 0 0 1.127.313 5.58 5.58 0 0 0 1.077.114c.338 0 .697-.038 1.078-.114a7.59 7.59 0 0 0 1.127-.313c.371-.13.702-.282.992-.46v.8Z" fill="#fff"/><defs><linearGradient :id="`${uniqueID}a`" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse"><stop stop-color="#471571"/><stop offset=".031" stop-color="#551B84"/><stop offset=".145" stop-color="#7C229E"/><stop offset=".237" stop-color="#9024A4"/><stop offset=".355" stop-color="#B02290"/><stop offset=".483" stop-color="#D32B86"/><stop offset=".603" stop-color="#E92F6F"/><stop offset=".701" stop-color="#F6484F"/><stop offset=".9" stop-color="#FB7328"/><stop offset=".973" stop-color="#F3960F"/><stop offset="1" stop-color="#F3960F"/></linearGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDialbot',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
